import React, { useRef, useState } from "react";
import ReactDOM from 'react-dom';
// Direct React component imports
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';

// Styles must use direct files imports
import 'swiper/swiper.scss'; // core Swiper

// Core modules imports are same as usual
import { Autoplay, Navigation, Pagination } from 'swiper';

class ProductSlider extends React.Component {

	componentWillUnmount() {

	}

	render() {

		return (

			<Swiper
				slidesPerView={1}
				navigation={true}
				autoHeight={true}
				watchOverflow={true}
				loop={document.querySelectorAll(".product-slider .swiper-slide").length > 1}
				pagination={{
					clickable: true,
				}}
				modules={[Autoplay, Navigation, Pagination]}
				className="mySwiper"
			>

			{this.props.slides.map(function(slide, index) {
				return (
						<SwiperSlide key={'image'+index} ><div className="product-view__product-details--image"><img className="lazyload" data-src={slide.image} alt={slide.alt} /></div></SwiperSlide>
				)
			}.bind(this))}

			</Swiper>

		)
	}
}

document.addEventListener('DOMContentLoaded', () => {

	var slider_list = document.querySelectorAll('.product-slider'); // returns NodeList
	var sliders = [...slider_list]; // converts NodeList to Array

	sliders.forEach(slider => {
		const slides = JSON.parse( slider.getAttribute('slides') );
		ReactDOM.render(
			<ProductSlider slides={slides} />,
			slider,
		)
	});
})
